import { useState } from 'react';
import { Download } from 'lucide-react';
import { format } from 'date-fns';
import Papa from 'papaparse';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { dispatchesApi } from '@/api/dispatches.api';
import { extractErrorMessage } from '@/lib/errors';
import type { DispatchFilters } from '@/hooks/useDispatches';

interface Props {
  filters: DispatchFilters;
}

export function ExportButton({ filters }: Props) {
  const [loading, setLoading] = useState(false);

  async function handleExport() {
    setLoading(true);
    try {
      const res = await dispatchesApi.list({ ...filters, page: 1, pageSize: 1000 });
      const rows = res.data.data;

      if (rows.length === 0) {
        toast.error('Nenhum disparo para exportar');
        return;
      }

      const csv = Papa.unparse(
        rows.map((d) => ({
          id: d.id,
          phone: d.contactPhone,
          name: d.contactName ?? '',
          status: d.status,
          sentAt: d.sentAt ?? '',
          deliveredAt: d.deliveredAt ?? '',
          readAt: d.readAt ?? '',
          failedAt: d.failedAt ?? '',
          errorMessage: d.errorMessage ?? '',
          campaignId: d.campaignId ?? '',
          zenviaMessageId: d.zenviaMessageId ?? '',
          createdAt: d.createdAt,
        }))
      );

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `disparos_${format(new Date(), 'yyyyMMdd_HHmm')}.csv`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success(`${rows.length} disparos exportados`);
    } catch (err) {
      toast.error(extractErrorMessage(err));
    } finally {
      setLoading(false);
    }
  }

  return (
    <Button variant="outline" disabled={loading} onClick={handleExport}>
      <Download className="h-4 w-4" />
      {loading ? 'Exportando…' : 'Exportar CSV'}
    </Button>
  );
}
